import { FeedbackReport } from '@run-diffusion/shared';
import { db } from '@/firebase';

// The report numbered `n`, or null when the server says there is none. A duplicate names the
// report it repeats by its number, and firestore.rules can't look a report up by number, so the page
// checks the report exists before it saves one. Offline, get() answers from the local cache, whose
// silence proves nothing: that rejects, as a lookup that couldn't be made.
export const findReportByNumber = async (n: number): Promise<FeedbackReport | null> => {
	const snap = await db.collection('feedbackReports').where('number', '==', n).limit(1).get();
	if (snap.empty && snap.metadata.fromCache) throw new Error(`Report #${n} can't be looked up offline`);
	return snap.empty ? null : { ...(snap.docs[0].data() as FeedbackReport), id: snap.docs[0].id };
};
